import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './ServiceCentersPage.css';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ServiceCentersPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [serviceCenters, setServiceCenters] = useState([]);

  useEffect(() => {
    const fetchCenters = async () => {
      try {
        const isLocalHost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname.startsWith('192.168.');
        const envApiUrl = process.env.REACT_APP_API_URL?.trim();
        const API_URL = envApiUrl && (isLocalHost || (!envApiUrl.includes("localhost") && !envApiUrl.includes("127.0.0.1"))) ? envApiUrl : '/api';
        
        const res = await fetch(`${API_URL}/service-centers`);
        const data = await res.json();
        if (data.success && Array.isArray(data.data)) {
          const activeCenters = data.data.filter(c => c.status === 'Active').map(c => ({
            id: c._id,
            name: c.name,
            address: c.address,
            phone: c.phone
          }));
          setServiceCenters(activeCenters);
        } else {
          setServiceCenters([]);
        }
      } catch (err) {
        console.error('Error fetching service centers:', err);
        setServiceCenters([]);
      }
    };
    fetchCenters();
  }, []);

  return (
    <div className="service-page">
      <Header />
      
      <main className="service-main">
        <div className="container">
          <div className="service-header">
            <h1 className="service-title">{t('service_centers_page.title')}</h1>
            <p className="service-subtitle">{t('service_centers_page.subtitle')}</p>
          </div>
          
          <div className="service-highlights">
            <div className="highlight-card green-highlight">
              <svg className="highlight-icon" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#4ba242" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
              </svg>
              <h3 className="highlight-title">{t('service_centers_page.genuine_title')}</h3>
              <p className="highlight-desc">{t('service_centers_page.genuine_desc')}</p>
            </div>
            <div className="highlight-card orange-highlight">
              <svg className="highlight-icon" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#e8762e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
              <h3 className="highlight-title">{t('service_centers_page.quick_title')}</h3>
              <p className="highlight-desc">{t('service_centers_page.quick_desc')}</p>
            </div>
          </div>
          
          <div className="services-section" style={{ margin: '60px 0' }}>
            <h2 className="service-title" style={{ fontSize: '32px', marginBottom: '8px' }}>Our Services</h2>
            <p className="service-subtitle" style={{ marginBottom: '40px' }}>We support Indian agriculture with advanced machinery loans, subsidies, maintenance support, and custom farmer offers.</p>
            
            <div className="services-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '30px', marginBottom: '60px' }}>
              {/* Card 1 */}
              <div className="service-card" style={{ background: '#ffffff', borderRadius: '12px', padding: '30px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.03)', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                <div className="service-card-icon-wrapper loan-icon" style={{ background: '#f0fdf4', color: '#4ba242', width: '48px', height: '48px', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect><rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect><line x1="6" y1="6" x2="6.01" y2="6"></line><line x1="6" y1="18" x2="6.01" y2="18"></line></svg>
                </div>
                <h3 className="highlight-title" style={{ fontSize: '18px' }}>Implements / Machinery Loan</h3>
                <p className="highlight-desc" style={{ fontSize: '14px', flex: 1 }}>Get fast-track financial assistance and flexible loans with minimum documentation for purchasing tractors, tillers, and heavy implements.</p>
                <button className="btn-call" style={{ width: '100%', padding: '10px 15px', fontSize: '14px', height: 'auto', border: '1.5px solid #4ba242' }} onClick={() => navigate('/services/loan')}>Enquire for Loan</button>
              </div>

              {/* Card 2 */}
              <div className="service-card" style={{ background: '#ffffff', borderRadius: '12px', padding: '30px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.03)', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                <div className="service-card-icon-wrapper service-icon" style={{ background: '#fff4ed', color: '#e8762e', width: '48px', height: '48px', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></svg>
                </div>
                <h3 className="highlight-title" style={{ fontSize: '18px' }}>Implements Service</h3>
                <p className="highlight-desc" style={{ fontSize: '14px', flex: 1 }}>Keep your machinery working like new. Get periodic tuning, blade replacements, and repair service at our authorized service centers.</p>
                <a href="#service-centers-list" className="btn-call" style={{ width: '100%', padding: '10px 15px', fontSize: '14px', height: 'auto', border: '1.5px solid #e8762e', color: '#e8762e', textDecoration: 'none', display: 'block', textAlign: 'center', boxSizing: 'border-box' }} onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('service-centers-list')?.scrollIntoView({ behavior: 'smooth' });
                }}>Find Service Center</a>
              </div>

              {/* Card 3 */}
              <div className="service-card" style={{ background: '#ffffff', borderRadius: '12px', padding: '30px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.03)', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                <div className="service-card-icon-wrapper subsidy-icon" style={{ background: '#f0fdf4', color: '#4ba242', width: '48px', height: '48px', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
                </div>
                <h3 className="highlight-title" style={{ fontSize: '18px' }}>Subsidy Apply</h3>
                <p className="highlight-desc" style={{ fontSize: '14px', flex: 1 }}>Government support made easy. Learn about central and state-level subsidy schemes and apply with our help to save on machinery purchases.</p>
                <button className="btn-call" style={{ width: '100%', padding: '10px 15px', fontSize: '14px', height: 'auto', border: '1.5px solid #4ba242' }} onClick={() => navigate('/services/subsidy')}>Apply for Subsidy</button>
              </div>

              {/* Card 4 */}
              <div className="service-card" style={{ background: '#ffffff', borderRadius: '12px', padding: '30px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.03)', display: 'flex', flexDirection: 'column', gap: '15px' }}>
                <div className="service-card-icon-wrapper offer-icon" style={{ background: '#fff4ed', color: '#e8762e', width: '48px', height: '48px', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line></svg>
                </div>
                <h3 className="highlight-title" style={{ fontSize: '18px' }}>Offer Plan</h3>
                <p className="highlight-desc" style={{ fontSize: '14px', flex: 1 }}>Never miss out on extra savings. Explore active crop-season discount packages, combo plans, and special exchange offers for implements.</p>
                <button className="btn-call" style={{ width: '100%', padding: '10px 15px', fontSize: '14px', height: 'auto', border: '1.5px solid #e8762e', color: '#e8762e' }} onClick={() => navigate('/offers')}>View Special Offers</button>
              </div>
            </div>
          </div>

          <div id="service-centers-list" className="service-header" style={{ marginTop: '60px', borderTop: '1px solid rgba(0,0,0,0.05)', paddingTop: '60px' }}>
            <h2 className="service-title">Our Authorized Service Centers</h2>
            <p className="service-subtitle">Visit any of our localized service hubs for genuine parts and support</p>
          </div>
          
          <div className="service-list">
            {serviceCenters.map((center) => (
              <div key={center.id} className="service-center-card">
                <h3 className="center-name">{center.name}</h3>
                <div className="center-details">
                  <div className="center-detail-item">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4ba242" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                    {center.address}
                  </div>
                  <div className="center-detail-item">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#e8762e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                    </svg>
                    {center.phone}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>

      {/* WhatsApp FAB */}
      <div className="whatsapp-fab" onClick={() => window.open('https://wa.me/919631277264', '_blank')} style={{ cursor: 'pointer' }}>
        <svg viewBox="0 0 24 24" width="32" height="32" fill="white">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.438 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.414 0 .004 5.412 0 12.046c0 2.123.555 4.195 1.608 6.014L0 24l6.117-1.605a11.782 11.782 0 005.925 1.587h.005c6.632 0 12.043-5.414 12.047-12.048a11.821 11.821 0 00-3.526-8.513"/>
        </svg>
      </div>

      <Footer />
    </div>
  );
};

export default ServiceCentersPage;


